<template lang="pug">
.pending
  .loading
    svg.frame(viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg")
      g
        frame-path-loop(ref="frame")
    .icon
      logo-image(ref="logoImage")
</template>
<script>
import LogoImage from '@/components/wedgits/LogoImage'
import FramePathLoop from '@/components/wedgits/FramePathLoop'
export default {
  name: 'Pending',
  components: { FramePathLoop, LogoImage },
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {
    this.$refs.logoImage.animeIn(1)
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.pending
  +full
  z-index: 999
  +flex-center
  background: rgba(255, 255, 255, 0.8)
  .loading
    width: pxToRem(128)
    height: pxToRem(128)
    position: relative
    .frame
      position: absolute
      width: 100%
    .icon
      position: absolute
      width: 160%
      height: 140%
      top: -10%
      left: -25%
</style>
